import { RESOURCE_URI } from 'shared/constants/global';
import { TaletsOfClassType } from 'shared/constants/talentsData';

export const rogue: TaletsOfClassType[] = [{
  title: 'assasination',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/182.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_rogue_eviscerate.jpg`,
  talents: [
    {
      id: 'rogue_assasination_improved_eviscerate',
      title: 'Improved Eviscerate',
      description: {
        1: 'Increases the damage done by your Eviscerate ability by 7%.',
        2: 'Increases the damage done by your Eviscerate ability by 14%.',
        3: 'Increases the damage done by your Eviscerate ability by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_eviscerate.jpg`,
      tier: 1,
      column: 1,
      max: 3,
    },
    {
      id: 'rogue_assasination_remorseless_attacks',
      title: 'Remorseless Attacks',
      description: {
        1: 'After killing an opponent that yields experience or honor, gives you a 20% increased critical strike chance on your next Sinister Strike, Hemorrhage, Backstab, Mutilate, Ambush, or Ghostly Strike. Lasts 20 sec.',
        2: 'After killing an opponent that yields experience or honor, gives you a 40% increased critical strike chance on your next Sinister Strike, Hemorrhage, Backstab, Mutilate, Ambush, or Ghostly Strike. Lasts 20 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_fiegndead.jpg`,
      tier: 1,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_assasination_malice',
      title: 'Malice',
      description: {
        1: 'Increases your critical strike chance by 1%.',
        2: 'Increases your critical strike chance by 2%.',
        3: 'Increases your critical strike chance by 3%.',
        4: 'Increases your critical strike chance by 4%.',
        5: 'Increases your critical strike chance by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_racial_bloodrage.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_assasination_ruthlessness',
      title: 'Ruthlessness',
      description: {
        1: 'Gives your melee finishing moves a 20% chance to add a combo point to your target.',
        2: 'Gives your melee finishing moves a 40% chance to add a combo point to your target.',
        3: 'Gives your melee finishing moves a 60% chance to add a combo point to your target.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_druid_disembowel.jpg`,
      tier: 2,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_assasination_blood_spatter',
      title: 'Blood Spatter',
      description: {
        1: 'Increases the damage caused by your Garrote and Rupture abilities by 15%.',
        2: 'Increases the damage caused by your Garrote and Rupture abilities by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_bloodsplatter.jpg`,
      tier: 2,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_assasination_puncturing_wounds',
      title: 'Puncturing Wounds',
      description: {
        1: 'Increases the critical strike chance of your Backstab ability by 10%, and the critical strike chance of your Mutilate ability by 5%.',
        2: 'Increases the critical strike chance of your Backstab ability by 20%, and the critical strike chance of your Mutilate ability by 10%.',
        3: 'Increases the critical strike chance of your Backstab ability by 30%, and the critical strike chance of your Mutilate ability by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_backstab.jpg`,
      tier: 2,
      column: 4,
      max: 3,
    }, {
      id: 'rogue_assasination_vigor',
      title: 'Vigor',
      description: {
        1: 'Increases your maximum Energy by 10.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_earthbindtotem.jpg`,
      tier: 3,
      column: 1,
      max: 1,
    }, {
      id: 'rogue_assasination_improved_expose_armor',
      title: 'Improved Expose Armor',
      description: {
        1: 'Reduces the energy cost of your Expose Armor ability by 5.',
        2: 'Reduces the energy cost of your Expose Armor ability by 10.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_riposte.jpg`,
      tier: 3,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_assasination_lethality',
      title: 'Lethality',
      description: {
        1: 'Increases the critical strike damage bonus of all combo point-generating abilities that do not require stealth by 6%.',
        2: 'Increases the critical strike damage bonus of all combo point-generating abilities that do not require stealth by 12%.',
        3: 'Increases the critical strike damage bonus of all combo point-generating abilities that do not require stealth by 18%.',
        4: 'Increases the critical strike damage bonus of all combo point-generating abilities that do not require stealth by 24%.',
        5: 'Increases the critical strike damage bonus of all combo point-generating abilities that do not require stealth by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_criticalstrike.jpg`,
      tier: 3,
      column: 3,
      max: 5,
      required: 'rogue_assasination_malice',
    }, {
      id: 'rogue_assasination_vile_poisons',
      title: 'Vile Poisons',
      description: {
        1: 'Increases the damage dealt by your poisons and Envenom ability by 7% and gives your damage over time poisons an additional 10% chance to resist dispel effects.',
        2: 'Increases the damage dealt by your poisons and Envenom ability by 14% and gives your damage over time poisons an additional 20% chance to resist dispel effects.',
        3: 'Increases the damage dealt by your poisons and Envenom ability by 20% and gives your damage over time poisons an additional 30% chance to resist dispel effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_feigndeath.jpg`,
      tier: 4,
      column: 2,
      max: 3,
    }, {
      id: 'rogue_assasination_improved_poisons',
      title: 'Improved Poisons',
      description: {
        1: 'Increases the chance to apply Deadly Poison to your target by 4% and the frequency of applying Instant Poison to your target by 10%.',
        2: 'Increases the chance to apply Deadly Poison to your target by 8% and the frequency of applying Instant Poison to your target by 20%.',
        3: 'Increases the chance to apply Deadly Poison to your target by 12% and the frequency of applying Instant Poison to your target by 30%.',
        4: 'Increases the chance to apply Deadly Poison to your target by 16% and the frequency of applying Instant Poison to your target by 40%.',
        5: 'Increases the chance to apply Deadly Poison to your target by 20% and the frequency of applying Instant Poison to your target by 50%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_poisons.jpg`,
      tier: 4,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_assasination_fleet_footed',
      title: 'Fleet Footed',
      description: {
        1: 'Reduces the duration of all movement impairing effects by 15% and increases your movement speed by 8%. This does not stack with other movement speed increasing effects.',
        2: 'Reduces the duration of all movement impairing effects by 30% and increases your movement speed by 15%. This does not stack with other movement speed increasing effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_fleetfooted.jpg`,
      tier: 5,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_assasination_cold_blood',
      title: 'Cold Blood',
      description: {
        1: 'When activated, increases the critical strike chance of your next offensive ability by 100%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_ice_lament.jpg`,
      tier: 5,
      column: 2,
      max: 1,
    }, {
      id: 'rogue_assasination_improved_kidney_shot',
      title: 'Improved Kidney Shot',
      description: {
        1: 'While affected by your Kidney Shot ability, the target receives an additional 3% damage from all sources.',
        2: 'While affected by your Kidney Shot ability, the target receives an additional 6% damage from all sources.',
        3: 'While affected by your Kidney Shot ability, the target receives an additional 9% damage from all sources.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_kidneyshot.jpg`,
      tier: 5,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_assasination_quick_recovery',
      title: 'Quick Recovery',
      description: {
        1: 'All healing effects on you are increased by 10%. In addition, your finishing moves refund 40% of their Energy cost when they fail to hit.',
        2: 'All healing effects on you are increased by 20%. In addition, your finishing moves refund 80% of their Energy cost when they fail to hit.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_quickrecovery.jpg`,
      tier: 5,
      column: 4,
      max: 2,
    }, {
      id: 'rogue_assasination_seal_fate',
      title: 'Seal Fate',
      description: {
        1: 'Your critical strikes from abilities that add combo points have a 20% chance to add an additional combo point.',
        2: 'Your critical strikes from abilities that add combo points have a 40% chance to add an additional combo point.',
        3: 'Your critical strikes from abilities that add combo points have a 60% chance to add an additional combo point.',
        4: 'Your critical strikes from abilities that add combo points have a 80% chance to add an additional combo point.',
        5: 'Your critical strikes from abilities that add combo points have a 100% chance to add an additional combo point.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_chilltouch.jpg`,
      tier: 6,
      column: 2,
      max: 5,
      required: 'rogue_assasination_cold_blood',
    }, {
      id: 'rogue_assasination_murder',
      title: 'Murder',
      description: {
        1: 'Increases all damage caused by 2%.',
        2: 'Increases all damage caused by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_deathscream.jpg`,
      tier: 6,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_assasination_deadly_brew',
      title: 'Deadly Brew',
      description: {
        1: 'When you apply Instant, Wound or Mind-Numbing poison to a target, you have a 50% chance to apply Crippling poison.',
        2: 'When you apply Instant, Wound or Mind-Numbing poison to a target, you have a 100% chance to apply Crippling poison.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_deadlybrew.jpg`,
      tier: 7,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_assasination_overkill',
      title: 'Overkill',
      description: {
        1: 'While stealthed, and for 20 seconds after breaking stealth, you regenerate 30% additional energy.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_rapidkilling.jpg`,
      tier: 7,
      column: 2,
      max: 1,
    }, {
      id: 'rogue_assasination_deadened_nerves',
      title: 'Deadened Nerves',
      description: {
        1: 'Reduces all damage taken by 2%.',
        2: 'Reduces all damage taken by 4%.',
        3: 'Reduces all damage taken by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_deadenednerves.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_assasination_focused_attacks',
      title: 'Focused Attacks',
      description: {
        1: 'Your melee critical strikes have a 33% chance to give you 2 energy.',
        2: 'Your melee critical strikes have a 66% chance to give you 2 energy.',
        3: 'Your melee critical strikes have a 100% chance to give you 2 energy.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_focusedattacks.jpg`,
      tier: 8,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_assasination_find_weakness',
      title: 'Find Weakness',
      description: {
        1: 'Offensive ability damage increased by 2%.',
        2: 'Offensive ability damage increased by 4%.',
        3: 'Offensive ability damage increased by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_findweakness.jpg`,
      tier: 8,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_assasination_master_poisoner',
      title: 'Master Poisoner',
      description: {
        1: 'Increases the critical hit chance of all attacks made against any target you have poisoned by 1%, reduces the duration of all Poison effects applied to you by 17%, and gives Envenom a 33% chance not to consume Deadly Poison.',
        2: 'Increases the critical hit chance of all attacks made against any target you have poisoned by 2%, reduces the duration of all Poison effects applied to you by 34%, and gives Envenom a 66% chance not to consume Deadly Poison.',
        3: 'Increases the critical hit chance of all attacks made against any target you have poisoned by 3%, reduces the duration of all Poison effects applied to you by 50%, and gives Envenom a 100% chance not to consume Deadly Poison.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_creature_poison_06.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_assasination_mutilate',
      title: 'Mutilate',
      description: {
        1: 'Instantly attacks with both weapons for % weapon damage plus an additional 44 with each weapon. Damage is increased by 20% against Poisoned targets. Awards 2 combo points.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_shadowstrikes.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      castDuration: 'instant',
      costs: '40 Energy',
      range: 0,
      required: 'rogue_assasination_overkill',
    }, {
      id: 'rogue_assasination_turn_the_bables',
      title: 'Turn the Tables',
      description: {
        1: 'Whenever anyone in your party or raid blocks, dodges, or parries an attack your chance to critically hit with all combo moves is increased by 2% for 8 sec.',
        2: 'Whenever anyone in your party or raid blocks, dodges, or parries an attack your chance to critically hit with all combo moves is increased by 4% for 8 sec.',
        3: 'Whenever anyone in your party or raid blocks, dodges, or parries an attack your chance to critically hit with all combo moves is increased by 6% for 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_turnthetables.jpg`,
      tier: 9,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_assasination_cut_to_the_chase',
      title: 'Cut to the Chase',
      description: {
        1: 'Your Eviscerate and Envenom abilities have a 20% chance to refresh your Slice and Dice duration to its 5 combo point maximum.',
        2: 'Your Eviscerate and Envenom abilities have a 40% chance to refresh your Slice and Dice duration to its 5 combo point maximum.',
        3: 'Your Eviscerate and Envenom abilities have a 60% chance to refresh your Slice and Dice duration to its 5 combo point maximum.',
        4: 'Your Eviscerate and Envenom abilities have a 80% chance to refresh your Slice and Dice duration to its 5 combo point maximum.',
        5: 'Your Eviscerate and Envenom abilities have a 100% chance to refresh your Slice and Dice duration to its 5 combo point maximum.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_cuttothechase.jpg`,
      tier: 10,
      column: 2,
      max: 5,
    }, {
      id: 'rogue_assasination_hunger_for_blood',
      title: 'Hunger For Blood',
      description: {
        1: 'Enrages you, increasing all damage caused by 5%. Requires a bleed effect to be active on the target. Lasts 1 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_hungerforblood.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      range: 30,
      costs: '15 Energy',
    },
  ],
}, {
  title: 'combat',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/181.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_backstab.jpg`,
  talents: [
    {
      id: 'rogue_combat_improved_gouge',
      title: 'Improved Gouge',
      description: {
        1: 'Increases the effect duration of your Gouge ability by 0.5 sec.',
        2: 'Increases the effect duration of your Gouge ability by 1 sec.',
        3: 'Increases the effect duration of your Gouge ability by 1.5 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_gouge.jpg`,
      tier: 1,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_combat_improved_sinister_strike',
      title: 'Improved Sinister Strike',
      description: {
        1: 'Reduces the Energy cost of your Sinister Strike ability by 3.',
        2: 'Reduces the Energy cost of your Sinister Strike ability by 5.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_ritualofsacrifice.jpg`,
      tier: 1,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_combat_dual_wield_specialization',
      title: 'Dual Wield Specialization',
      description: {
        1: 'Increases the damage done by your offhand weapon by 10%.',
        2: 'Increases the damage done by your offhand weapon by 20%.',
        3: 'Increases the damage done by your offhand weapon by 30%.',
        4: 'Increases the damage done by your offhand weapon by 40%.',
        5: 'Increases the damage done by your offhand weapon by 50%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_dualwield.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_combat_improved_slice_and_dice',
      title: 'Improved Slice and Dice',
      description: {
        1: 'Increases the duration of your Slice and Dice ability by 25%.',
        2: 'Increases the duration of your Slice and Dice ability by 50%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_slicedice.jpg`,
      tier: 2,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_combat_deflection',
      title: 'Deflection',
      description: {
        1: 'Increases your Parry chance by 2%.',
        2: 'Increases your Parry chance by 4%.',
        3: 'Increases your Parry chance by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_parry.jpg`,
      tier: 2,
      column: 2,
      max: 3,
    }, {
      id: 'rogue_combat_precision',
      title: 'Precision',
      description: {
        1: 'Increases your chance to hit with weapon and poison attacks by 1%.',
        2: 'Increases your chance to hit with weapon and poison attacks by 2%.',
        3: 'Increases your chance to hit with weapon and poison attacks by 3%.',
        4: 'Increases your chance to hit with weapon and poison attacks by 4%.',
        5: 'Increases your chance to hit with weapon and poison attacks by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_marksmanship.jpg`,
      tier: 2,
      column: 4,
      max: 5,
    }, {
      id: 'rogue_combat_endurance',
      title: 'Endurance',
      description: {
        1: 'Reduces the cooldown of your Sprint and Evasion abilities by 30 sec and increases your total Stamina by 2%.',
        2: 'Reduces the cooldown of your Sprint and Evasion abilities by 60 sec and increases your total Stamina by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_shadowward.jpg`,
      tier: 3,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_combat_riposte',
      title: 'Riposte',
      description: {
        1: 'A strike that becomes active after parrying an opponent\'s attack. This attack deals 150% weapon damage and slows their melee attack speed by 20% for 30 sec. Awards 1 combo point.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_challange.jpg`,
      tier: 3,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 6,
      costs: '10 Energy',
      range: 0,
      required: 'rogue_combat_deflection',
    }, {
      id: 'rogue_combat_close_quarters_combat',
      title: 'Close Quarters Combat',
      description: {
        1: 'Increases your chance to get a critical strike with Daggers and Fist Weapons by 1%.',
        2: 'Increases your chance to get a critical strike with Daggers and Fist Weapons by 2%.',
        3: 'Increases your chance to get a critical strike with Daggers and Fist Weapons by 3%.',
        4: 'Increases your chance to get a critical strike with Daggers and Fist Weapons by 4%.',
        5: 'Increases your chance to get a critical strike with Daggers and Fist Weapons by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_weapon_shortblade_05.jpg`,
      tier: 3,
      column: 3,
      max: 5,
      required: 'rogue_combat_dual_wield_specialization',
    }, {
      id: 'rogue_combat_improved_kick',
      title: 'Improved Kick',
      description: {
        1: 'Gives your Kick ability a 50% chance to silence the target for 2 sec.',
        2: 'Gives your Kick ability a 100% chance to silence the target for 2 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_kick.jpg`,
      tier: 4,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_combat_improved_sprint',
      title: 'Improved Sprint',
      description: {
        1: 'Gives a 50% chance to remove all Movement Impairing effects when you activate your Sprint ability.',
        2: 'Gives a 100% chance to remove all Movement Impairing effects when you activate your Sprint ability.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_sprint.jpg`,
      tier: 4,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_combat_lightning_reflexes',
      title: 'Lightning Reflexes',
      description: {
        1: 'Increases your Dodge chance by 2% and gives you 4% melee haste.',
        2: 'Increases your Dodge chance by 4% and gives you 7% melee haste.',
        3: 'Increases your Dodge chance by 6% and gives you 10% melee haste.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_invisibilty.jpg`,
      tier: 4,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_combat_aggression',
      title: 'Aggression',
      description: {
        1: 'Increases the damage of your Sinister Strike, Backstab, and Eviscerate abilities by 3%.',
        2: 'Increases the damage of your Sinister Strike, Backstab, and Eviscerate abilities by 6%.',
        3: 'Increases the damage of your Sinister Strike, Backstab, and Eviscerate abilities by 9%.',
        4: 'Increases the damage of your Sinister Strike, Backstab, and Eviscerate abilities by 12%.',
        5: 'Increases the damage of your Sinister Strike, Backstab, and Eviscerate abilities by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_racial_avatar.jpg`,
      tier: 4,
      column: 4,
      max: 5,
    }, {
      id: 'rogue_combat_mace_specialization',
      title: 'Mace Specialization',
      description: {
        1: 'Your attacks with maces ignore up to 3% of your opponent\'s armor.',
        2: 'Your attacks with maces ignore up to 6% of your opponent\'s armor.',
        3: 'Your attacks with maces ignore up to 9% of your opponent\'s armor.',
        4: 'Your attacks with maces ignore up to 12% of your opponent\'s armor.',
        5: 'Your attacks with maces ignore up to 15% of your opponent\'s armor.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_mace_01.jpg`,
      tier: 5,
      column: 1,
      max: 5,
    }, {
      id: 'rogue_combat_blade_flurry',
      title: 'Blade Flurry',
      description: {
        1: 'Increases your attack speed by 20%. In addition, attacks strike an additional nearby opponent. Lasts 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_punishingblow.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 120,
      costs: '25 Energy',
    }, {
      id: 'rogue_combat_hack_and_slash',
      title: 'Hack and Slash',
      description: {
        1: 'Gives you a 1% chance to get an extra attack on the same target after hitting your target with your Sword or Axe.',
        2: 'Gives you a 2% chance to get an extra attack on the same target after hitting your target with your Sword or Axe.',
        3: 'Gives you a 3% chance to get an extra attack on the same target after hitting your target with your Sword or Axe.',
        4: 'Gives you a 4% chance to get an extra attack on the same target after hitting your target with your Sword or Axe.',
        5: 'Gives you a 5% chance to get an extra attack on the same target after hitting your target with your Sword or Axe.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_sword_27.jpg`,
      tier: 5,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_combat_weapon_expertise',
      title: 'Weapon Expertise',
      description: {
        1: 'Increases your expertise by 5.',
        2: 'Increases your expertise by 10.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_blessingofstrength.jpg`,
      tier: 6,
      column: 2,
      max: 2,
      required: 'rogue_combat_blade_flurry',
    }, {
      id: 'rogue_combat_blade_twisting',
      title: 'Blade Twisting',
      description: {
        1: 'Increases the damage dealt by Sinister Strike and Backstab by 5%, and your damaging melee attacks have a 10% chance to Daze the target for 4 sec.',
        2: 'Increases the damage dealt by Sinister Strike and Backstab by 10%, and your damaging melee attacks have a 10% chance to Daze the target for 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_bladetwisting.jpg`,
      tier: 6,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_combat_vitality',
      title: 'Vitality',
      description: {
        1: 'Increases your Energy regeneration rate by 8%.',
        2: 'Increases your Energy regeneration rate by 16%.',
        3: 'Increases your Energy regeneration rate by 25%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_revenge.jpg`,
      tier: 7,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_combat_adrenaline_rush',
      title: 'Adrenaline Rush',
      description: {
        1: 'Increases your Energy regeneration rate by 100% for 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_shadowworddominate.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 180,
    }, {
      id: 'rogue_combat_nerves_of_steel',
      title: 'Nerves of Steel',
      description: {
        1: 'Reduces damage taken while affected by Stun and Fear effects by 15%.',
        2: 'Reduces damage taken while affected by Stun and Fear effects by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_nervesofsteel.jpg`,
      tier: 7,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_combat_throwing_specialization',
      title: 'Throwing Specialization',
      description: {
        1: 'Increases the range of Throw and Deadly Throw by 2 yards and gives your Deadly Throw a 50% chance to interrupt the target for 3 sec.',
        2: 'Increases the range of Throw and Deadly Throw by 4 yards and gives your Deadly Throw a 100% chance to interrupt the target for 3 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_throwingspecialization.jpg`,
      tier: 8,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_combat_combat_potency',
      title: 'Combat Potency',
      description: {
        1: 'Gives your successful off-hand melee attacks a 20% chance to generate 3 Energy.',
        2: 'Gives your successful off-hand melee attacks a 20% chance to generate 6 Energy.',
        3: 'Gives your successful off-hand melee attacks a 20% chance to generate 9 Energy.',
        4: 'Gives your successful off-hand melee attacks a 20% chance to generate 12 Energy.',
        5: 'Gives your successful off-hand melee attacks a 20% chance to generate 15 Energy.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_weapon_shortblade_38.jpg`,
      tier: 8,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_combat_unfair_advantage',
      title: 'Unfair Advantage',
      description: {
        1: 'Whenever you dodge an attack you gain an Unfair Advantage, striking back for 50% of your main hand weapon\'s damage. This cannot occur more than once per second.',
        2: 'Whenever you dodge an attack you gain an Unfair Advantage, striking back for 100% of your main hand weapon\'s damage. This cannot occur more than once per second.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_unfairadvantage.jpg`,
      tier: 9,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_combat_surprise_attacks',
      title: 'Surprise Attacks',
      description: {
        1: 'Your finishing moves can no longer be dodged, and the damage dealt by your Sinister Strike, Backstab, Shiv, Hemorrhage and Gouge abilities is increased by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_surpriseattack.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      required: 'rogue_combat_adrenaline_rush',
    }, {
      id: 'rogue_combat_savage_combat',
      title: 'Savage Combat',
      description: {
        1: 'Increases your total attack power by 2% and all physical damage caused to enemies you have poisoned is increased by 2%.',
        2: 'Increases your total attack power by 4% and all physical damage caused to enemies you have poisoned is increased by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_creature_disease_03.jpg`,
      tier: 9,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_combat_prey_on_the_weak',
      title: 'Prey on the Weak',
      description: {
        1: 'Your critical strike damage is increased by 4% when the target has less health than you (as a percentage of total health).',
        2: 'Your critical strike damage is increased by 8% when the target has less health than you (as a percentage of total health).',
        3: 'Your critical strike damage is increased by 12% when the target has less health than you (as a percentage of total health).',
        4: 'Your critical strike damage is increased by 16% when the target has less health than you (as a percentage of total health).',
        5: 'Your critical strike damage is increased by 20% when the target has less health than you (as a percentage of total health).',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_preyontheweak.jpg`,
      tier: 10,
      column: 2,
      max: 5,
    }, {
      id: 'rogue_combat_killing_spree',
      title: 'Killing Spree',
      description: {
        1: 'Step through the shadows from enemy to enemy within 10 yards, attacking an enemy every .5 secs with both weapons until 5 assaults are made, and increasing all damage done by 20% for the duration. Can hit the same target multiple times. Cannot hit invisible or stealthed targets.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_murderspree.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 120,
      range: 10,
    },
  ],
}, {
  title: 'subtlety',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/183.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_stealth.jpg`,
  talents: [
    {
      id: 'rogue_subtlety_spirit_tap',
      title: 'Relentless Strikes',
      description: {
        1: 'Your finishing moves have a 4% chance per combo point to restore 25 energy.',
        2: 'Your finishing moves have a 8% chance per combo point to restore 25 energy.',
        3: 'Your finishing moves have a 12% chance per combo point to restore 25 energy.',
        4: 'Your finishing moves have a 16% chance per combo point to restore 25 energy.',
        5: 'Your finishing moves have a 20% chance per combo point to restore 25 energy.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_decisivestrike.jpg`,
      tier: 1,
      column: 1,
      max: 5,
    }, {
      id: 'rogue_subtlety_master_of_deception',
      title: 'Master of Deception',
      description: {
        1: 'Reduces the chance enemies have to detect you while in Stealth mode.',
        2: 'Reduces the chance enemies have to detect you while in Stealth mode. More effective than Master of Deception (Rank 1).',
        3: 'Reduces the chance enemies have to detect you while in Stealth mode. More effective than Master of Deception (Rank 2).',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_charm.jpg`,
      tier: 1,
      column: 2,
      max: 3,
    }, {
      id: 'rogue_subtlety_opportunity',
      title: 'Opportunity',
      description: {
        1: 'Increases the damage dealt with your Backstab, Mutilate, Garrote and Ambush abilities by 10%.',
        2: 'Increases the damage dealt with your Backstab, Mutilate, Garrote and Ambush abilities by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_warcry.jpg`,
      tier: 1,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_subtlety_sleight_of_hand',
      title: 'Sleight of Hand',
      description: {
        1: 'Reduces the chance you are critically hit by melee and ranged attacks by 1% and increases the threat reduction of your Feint ability by 10%.',
        2: 'Reduces the chance you are critically hit by melee and ranged attacks by 2% and increases the threat reduction of your Feint ability by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_feint.jpg`,
      tier: 2,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_subtlety_dirty_tricks',
      title: 'Dirty Tricks',
      description: {
        1: 'Increases the range of your Blind and Sap abilities by 2 yards and reduces the energy cost of your Blind and Sap abilities by 25%.',
        2: 'Increases the range of your Blind and Sap abilities by 5 yards and reduces the energy cost of your Blind and Sap abilities by 50%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_sap.jpg`,
      tier: 2,
      column: 2,
      max: 2,
    }, {
      id: 'rogue_subtlety_camouflage',
      title: 'Camouflage',
      description: {
        1: 'Increases your speed while stealthed by 5% and reduces the cooldown of your Stealth ability by 2 sec.',
        2: 'Increases your speed while stealthed by 10% and reduces the cooldown of your Stealth ability by 4 sec.',
        3: 'Increases your speed while stealthed by 15% and reduces the cooldown of your Stealth ability by 6 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_stealth.jpg`,
      tier: 2,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_subtlety_elusiveness',
      title: 'Elusiveness',
      description: {
        1: 'Reduces the cooldown of your Vanish and Blind abilities by 30 sec and your Cloak of Shadows ability by 15 sec.',
        2: 'Reduces the cooldown of your Vanish and Blind abilities by 60 sec and your Cloak of Shadows ability by 30 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_magic_lesserinvisibilty.jpg`,
      tier: 3,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_subtlety_ghostly_strike',
      title: 'Ghostly Strike',
      description: {
        1: 'A strike that deals 125% weapon damage (180% if a dagger is equipped) and increases your chance to dodge by 15% for 7 sec. Awards 1 combo point.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_curse.jpg`,
      tier: 3,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 20,
      costs: '40 Energy',
      range: 0,
    }, {
      id: 'rogue_subtlety_serrated_blades',
      title: 'Serrated Blades',
      description: {
        1: 'Causes your attacks to ignore up to 3% of your target\'s Armor and increases the damage dealt by your Rupture ability by 10%.',
        2: 'Causes your attacks to ignore up to 6% of your target\'s Armor and increases the damage dealt by your Rupture ability by 20%.',
        3: 'Causes your attacks to ignore up to 9% of your target\'s Armor and increases the damage dealt by your Rupture ability by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_sword_17.jpg`,
      tier: 3,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_subtlety_setup',
      title: 'Setup',
      description: {
        1: 'Gives you a 33% chance to add a combo point to your target after dodging their attack or fully resisting one of their spells. This cannot happen more than once per second.',
        2: 'Gives you a 66% chance to add a combo point to your target after dodging their attack or fully resisting one of their spells. This cannot happen more than once per second.',
        3: 'Gives you a 100% chance to add a combo point to your target after dodging their attack or fully resisting one of their spells. This cannot happen more than once per second.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_mirrorimage.jpg`,
      tier: 4,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_subtlety_initiative',
      title: 'Initiative',
      description: {
        1: 'Gives you a 33% chance to add an additional combo point to your target when using your Ambush, Garrote, or Cheap Shot ability.',
        2: 'Gives you a 66% chance to add an additional combo point to your target when using your Ambush, Garrote, or Cheap Shot ability.',
        3: 'Gives you a 100% chance to add an additional combo point to your target when using your Ambush, Garrote, or Cheap Shot ability.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_fumble.jpg`,
      tier: 4,
      column: 2,
      max: 3,
    }, {
      id: 'rogue_subtlety_improved_ambush',
      title: 'Improved Ambush',
      description: {
        1: 'Increases the critical strike chance of your Ambush ability by 25%.',
        2: 'Increases the critical strike chance of your Ambush ability by 50%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_ambush.jpg`,
      tier: 4,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_subtlety_heightened_senses',
      title: 'Heightened Senses',
      description: {
        1: 'Increases your Stealth detection and reduces the chance you are hit by spells and ranged attacks by 2%.',
        2: 'Increases your Stealth detection and reduces the chance you are hit by spells and ranged attacks by 4%. More effective than Heightened Senses (Rank 1).',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_ambush.jpg`,
      tier: 5,
      column: 1,
      max: 2,
    }, {
      id: 'rogue_subtlety_preparation',
      title: 'Preparation',
      description: {
        1: 'When activated, this ability immediately finishes the cooldown on your Evasion, Sprint, Vanish, Cold Blood and Shadowstep abilities.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_antishadow.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      cooldown: 480,
    }, {
      id: 'rogue_subtlety_dirty_deeds',
      title: 'Dirty Deeds',
      description: {
        1: 'Reduces the Energy cost of your Cheap Shot and Garrote abilities by 10. Additionally, your special abilities cause 10% more damage against targets below 35% health.',
        2: 'Reduces the Energy cost of your Cheap Shot and Garrote abilities by 20. Additionally, your special abilities cause 20% more damage against targets below 35% health.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_summonsuccubus.jpg`,
      tier: 5,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_subtlety_hemorrhage',
      title: 'Hemorrhage',
      description: {
        1: 'An instant strike that deals 110% weapon damage (160% if a dagger is equipped) and causes the target to hemorrhage, increasing any Physical damage dealt to the target by up to. Lasts 10 charges or 15 sec. Awards 1 combo point.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_lifedrain.jpg`,
      tier: 5,
      column: 4,
      max: 1,
      castDuration: 'instant',
      costs: '35 Energy',
      range: 0,
      required: 'rogue_subtlety_serrated_blades',
    }, {
      id: 'rogue_subtlety_master_of_subtlety',
      title: 'Master of Subtlety',
      description: {
        1: 'Attacks made while stealthed and for 6 seconds after breaking stealth cause an additional 4% damage.',
        2: 'Attacks made while stealthed and for 6 seconds after breaking stealth cause an additional 7% damage.',
        3: 'Attacks made while stealthed and for 6 seconds after breaking stealth cause an additional 10% damage.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_masterofsubtlety.jpg`,
      tier: 6,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_subtlety_deadliness',
      title: 'Deadliness',
      description: {
        1: 'Increases your attack power by 2%.',
        2: 'Increases your attack power by 4%.',
        3: 'Increases your attack power by 6%.',
        4: 'Increases your attack power by 8%.',
        5: 'Increases your attack power by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_weapon_crossbow_11.jpg`,
      tier: 6,
      column: 3,
      max: 5,
    }, {
      id: 'rogue_subtlety_enveloping_shadows',
      title: 'Enveloping Shadows',
      description: {
        1: 'Reduces the damage taken by area of effect attacks by 10%.',
        2: 'Reduces the damage taken by area of effect attacks by 20%.',
        3: 'Reduces the damage taken by area of effect attacks by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_envelopingshadows.jpg`,
      tier: 7,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_subtlety_premeditation',
      title: 'Premeditation',
      description: {
        1: 'When used, adds 2 combo points to your target. You must add to or use those combo points within 20 sec or the combo points are lost.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_possession.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 20,
      range: 30,
      required: 'rogue_subtlety_preparation',
    }, {
      id: 'rogue_subtlety_cheat_death',
      title: 'Cheat Death',
      description: {
        1: 'You have a 33% chance that an attack which would otherwise kill you will instead reduce you to 10% of your maximum health. In addition, all damage taken will be reduced by up to 90% for 3 sec (modified by resilience). This effect cannot occur more than once per minute.',
        2: 'You have a 66% chance that an attack which would otherwise kill you will instead reduce you to 10% of your maximum health. In addition, all damage taken will be reduced by up to 90% for 3 sec (modified by resilience). This effect cannot occur more than once per minute.',
        3: 'You have a 100% chance that an attack which would otherwise kill you will instead reduce you to 10% of your maximum health. In addition, all damage taken will be reduced by up to 90% for 3 sec (modified by resilience). This effect cannot occur more than once per minute.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_cheatdeath.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'rogue_subtlety_sinister_calling',
      title: 'Sinister Calling',
      description: {
        1: 'Increases your total Agility by 3% and increases the percentage damage bonus of Backstab and Hemorrhage by an additional 2%.',
        2: 'Increases your total Agility by 6% and increases the percentage damage bonus of Backstab and Hemorrhage by an additional 4%.',
        3: 'Increases your total Agility by 9% and increases the percentage damage bonus of Backstab and Hemorrhage by an additional 6%.',
        4: 'Increases your total Agility by 12% and increases the percentage damage bonus of Backstab and Hemorrhage by an additional 8%.',
        5: 'Increases your total Agility by 15% and increases the percentage damage bonus of Backstab and Hemorrhage by an additional 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_sinistercalling.jpg`,
      tier: 8,
      column: 2,
      max: 5,
      required: 'rogue_subtlety_premeditation',
    }, {
      id: 'rogue_subtlety_waylay',
      title: 'Waylay',
      description: {
        1: 'Your Ambush and Backstab hits have a 50% chance to unbalance a target, increasing the time between their melee and ranged attacks by 20%, and reducing movement speed by 50% for 8 sec.',
        2: 'Your Ambush and Backstab hits have a 100% chance to unbalance a target, increasing the time between their melee and ranged attacks by 20%, and reducing movement speed by 50% for 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_waylay.jpg`,
      tier: 8,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_subtlety_honor_among_thieves',
      title: 'Honor Among Thieves',
      description: {
        1: 'When anyone in your group critically hits with a damage or healing spell or ability, you have a 33% chance to gain a combo point on your current target. This effect cannot occur more than once every second.',
        2: 'When anyone in your group critically hits with a damage or healing spell or ability, you have a 66% chance to gain a combo point on your current target. This effect cannot occur more than once every second.',
        3: 'When anyone in your group critically hits with a damage or healing spell or ability, you have a 100% chance to gain a combo point on your current target. This effect cannot occur more than once every second.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_honoramongstthieves.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'rogue_subtlety_shadowstep',
      title: 'Shadowstep',
      description: {
        1: 'Attempts to step through the shadows and reappear behind your enemy and increases movement speed by 70% for 3 sec. The damage of your next ability is increased by 20% and the threat caused is reduced by 50%. Lasts 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_shadowstep.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 30,
      costs: '10 Energy',
      range: 25,
    }, {
      id: 'rogue_subtlety_filthy_tricks',
      title: 'Filthy Tricks',
      description: {
        1: 'Reduces the cooldown by 5 sec and energy cost by 5 of your Tricks of the Trade, Distract and Shadowstep abilities and reduces the cooldown of Preparation by 1.5 min.',
        2: 'Reduces the cooldown by 10 sec and energy cost by 10 of your Tricks of the Trade, Distract and Shadowstep abilities and reduces the cooldown of Preparation by 3 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_wrongfullyaccused.jpg`,
      tier: 9,
      column: 3,
      max: 2,
    }, {
      id: 'rogue_subtlety_slaughter_from_the_shadows',
      title: 'Slaughter from the Shadows',
      description: {
        1: 'Reduces the energy cost of your Backstab and Ambush abilities by 4 and the energy cost of your Hemorrhage by 1, and increases all damage done by 1%.',
        2: 'Reduces the energy cost of your Backstab and Ambush abilities by 8 and the energy cost of your Hemorrhage by 2, and increases all damage done by 2%.',
        3: 'Reduces the energy cost of your Backstab and Ambush abilities by 12 and the energy cost of your Hemorrhage by 3, and increases all damage done by 3%.',
        4: 'Reduces the energy cost of your Backstab and Ambush abilities by 16 and the energy cost of your Hemorrhage by 4, and increases all damage done by 4%.',
        5: 'Reduces the energy cost of your Backstab and Ambush abilities by 20 and the energy cost of your Hemorrhage by 5, and increases all damage done by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_slaughterfromtheshadows.jpg`,
      tier: 10,
      column: 2,
      max: 5,
    }, {
      id: 'rogue_subtlety_shadow_dance',
      title: 'Shadow Dance',
      description: {
        1: 'Enter the Shadow Dance for 6 sec, allowing the use of Sap, Garrote, Ambush, Cheap Shot, Premeditation, Pickpocket and Disarm Trap regardless of being stealthed.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_shadowdance.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 60,
    },
  ],
}];
